import { useEffect } from 'react'

import CobranzasTemplate from 'Components/UI/Templates/Sales/Cobranzas'

const Cobranzas = () => {
  useEffect(() => {
    document.title = 'Cobranzas'
  }, [])
  return <CobranzasTemplate />
}

export default Cobranzas
